import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TextField, Button, Stack, Typography } from '@mui/material';

import { useAppContext } from '../context/AppContext';

const defaultForm = {
    profile: '',
    profile_category: '',
    country: '',
    pki_name: '',
    description: '',
};

const RAProfileForm = ({ onSubmit, initialData }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { raProfile, getRAProfile, postRAProfile, putRAProfile } = useAppContext();
    const isEditMode = Boolean(id);
    const [form, setForm] = useState(initialData || defaultForm);

    useEffect(() => {
        if (isEditMode) {
            getRAProfile(decodeURIComponent(id));
        }
    }, [id, isEditMode]);

    useEffect(() => {
        if (isEditMode && raProfile && Object.keys(raProfile).length > 0) {
            setForm({
                profile: raProfile.profile || '',
                profile_category: raProfile.profile_category || '',
                country: raProfile.country || '',
                pki_name: raProfile.pki_name || '',
                description: raProfile.description || '',
            });
        }
    }, [raProfile, isEditMode]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (isEditMode) {
                await putRAProfile(decodeURIComponent(id), form);
            } else {
                await postRAProfile(form);
            }

            if (onSubmit) {
                onSubmit(form);
            }

            navigate('/ra-profiles');
        } catch (err) {
            console.error('Error saving RA profile:', err);
            alert('Error saving RA profile');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Typography variant="h6">RA Profile Form</Typography>
            <Stack spacing={2} direction="column" sx={{ my: 2 }}>
                <TextField
                    label="Profile"
                    name="profile"
                    value={form.profile}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    label="Profile Category"
                    name="profile_category"
                    value={form.profile_category}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    label="Country"
                    name="country"
                    value={form.country}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    label="PKI Name"
                    name="pki_name"
                    value={form.pki_name}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    label="Description"
                    name="description"
                    value={form.description}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    minRows={3}
                />
                <Button variant="contained" type="submit" fullWidth>
                    {isEditMode ? 'Update RA Profile' : 'Create RA Profile'}
                </Button>
            </Stack>
        </form>
    );
};

export default RAProfileForm;
